import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTimezone } from '@urc-ui/services/app-context';
import { useLocalizedDate } from '@urc-ui/hooks/i18n';
import { SINGLE_BRACKET_INTERPOLATION_OPTION } from '@urc-ui/utils/i18n-constants';
import styled from 'styled-components';
import { Alert } from '@amzn/storm-ui';
import { isValidDate } from '@urc-ui/utils/date-utils';

const StyledAlert = styled(Alert)`
  margin: ${({ theme }) => theme.spacing.base.default};
`;

export function OutageBanner(props: { end: string }) {
  const { t: translate } = useTranslation();

  const endDate = new Date(props.end);
  const timeZone = getTimezone();

  const [endTime] = useLocalizedDate([
    {
      value: endDate,
      format: {
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
        timeZone
      }
    }
  ]);

  if (!props.end || !isValidDate(endDate)) {
    throw new Error(`Invalid date supplied to OutageBanner: ${props.end}`);
  }

  const descriptionText = translate(
    'sspa_rcm_ad_reports_outage_description_interpolate',
    'The report center isn’t available right now. Please come back at {endTime}. We’re sorry for the inconvenience.',
    {
      endTime,
      interpolation: SINGLE_BRACKET_INTERPOLATION_OPTION
    }
  );
  const headerText = translate('sspa_rcm_ad_reports_outage_header', 'Scheduled report center maintenance');

  return (
    <StyledAlert id='outage-banner' variant='error' header={headerText}>
      {descriptionText}
    </StyledAlert>
  );
}
